export default ({ onBackButtonPress }) => {
    window.onpopstate = e => {
        e.preventDefault();
        onBackButtonPress();
    };
};
